module.exports = __webpack_public_path__ + "img/rge.2f77221f.png";